import {useQueryClient, useMutation} from 'react-query'
import {KTSVG, QUERIES} from '../../../../../../../_metronic/helpers'
import {useListView} from '../../core/ListViewProvider'
import {useQueryResponse} from '../../core/QueryResponseProvider'
import {useState} from 'react'
import { fetchContentWebsite } from '../../core/_requests'

interface EmbeddignsListGroupingProps {
  handletableLoading: (value: boolean) => void
  setDataHandler: (value: string) => void

}

const EmbeddignsListGrouping: React.FC<EmbeddignsListGroupingProps> = ({handletableLoading,setDataHandler}) => {
  const {selected, clearSelected} = useListView()
  const queryClient = useQueryClient()
  const {query} = useQueryResponse()
  const [fetchingCount, setFetchingCount] = useState(0)
  const [isGenerating, setIsGenerating] = useState(true)
  const [contentArray, setContentArray] = useState<string[]>([]);

  async function fetchContent() {
    handletableLoading(true)
    setFetchingCount(0) 

    const collectedContent: string[] = []; // Initialize an array to collect content

    for (const link of selected) {
      const data = await fetchContentWebsite(link);
      setFetchingCount((prevCount) => prevCount + 1);
      if (data) {
        collectedContent.push(data.content); // Add content to the array
        console.log('Fetched data:', data.content);
      }
      const delayTime = 1000 
      await new Promise((resolve) => setTimeout(resolve, delayTime))
    }

    setContentArray(collectedContent); // Store the collected content
    handletableLoading(false)
    setIsGenerating(false) 
  }


  return (
    <div className='d-flex justify-content-end align-items-center'>
      <div className='fw-bolder me-5'>
        <span className='me-2'>{selected.length}</span> Selected
      </div>

      <button type='button' className='btn btn-sm btn-primary me-3' onClick={fetchContent}>
        <KTSVG path='/media/icons\duotune/custom/find.svg' className='svg-icon-3' />
        {fetchingCount === 0 ? 'Fetch Content' : `Fetching ${fetchingCount} of ${selected.length}`}
      </button>

      <button
        type='button'
        className='btn btn-sm btn-primary'
        disabled={isGenerating}
        onClick={() => {
          clearSelected();
          setFetchingCount(0);
          setIsGenerating(true); // Disable the button while processing
          setDataHandler(contentArray.join('\n')); // Join content array into a single string
        }}      >
        <KTSVG path='/media/icons\duotune/custom/add.svg' className='svg-icon-3' /> View Content
      </button>
    </div>
  )
}

export {EmbeddignsListGrouping}
